import { NbiDimensions } from "../../common/generic/generic-nbi-dimensions";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";
import {
  ICprGbisSearchCriteria,
  IHeaders,
  INbiKpi,
  INbiResponse,
} from "../../common/utils/types";

interface IGroupData {
  l1: string;
  ytd: number;
}

export class RevenuesPerProductsOutput {
  public constructor(public data: any[], public drillDownData: any[]) {}
}

// tslint:disable-next-line: cognitive-complexity
export function mapData(data: IGenericAggregateResponse): RevenuesPerProductsOutput {
  if (data.aggregates && data.aggregates.length === 0) {
    return new RevenuesPerProductsOutput([], []);
  }
  const dimensions = new NbiDimensions();
  const pieData: any = [];
  const kpiPieData: any = [];
  const kpiPieDrillDownData: any = [];
  const l1Values: IGroupData[] = [];
  let totalNbi = 0;
  let i = -1;
  let axis: string = "";

  for (const item of data.aggregates ? data.aggregates : []) {
    if (
      item.dimensionAttributeValues[dimensions.PRODUCT_LEVEL1] != null &&
      item.dimensionAttributeValues[dimensions.PRODUCT_LEVEL2] != null
    ) {
      const curYtd = checkNan(item.indicatorKpiValues.nbi_ytd);
      if (axis !== item.dimensionAttributeValues[dimensions.PRODUCT_LEVEL1]) {
        axis = item.dimensionAttributeValues[dimensions.PRODUCT_LEVEL1];
        l1Values.push({
          l1: item.dimensionAttributeValues[dimensions.PRODUCT_LEVEL1],
          ytd: 0,
        });
        i++;
      }
      l1Values[i].ytd += curYtd;
      totalNbi += curYtd;
    }
  }

  l1Values.sort((leftSide, rightSide): number => {
    if (leftSide.ytd < rightSide.ytd) {
      return 1;
    }
    if (leftSide.ytd > rightSide.ytd) {
      return -1;
    }
    return 0;
  });

  i = 0;

  let kpiDataSeries: any[] = [];
  let NbiperBl = 0;

  l1Values.forEach(element => {
    if (i <= 5) {
      kpiDataSeries = [];
      NbiperBl = 0;
    }

    for (const item of data.aggregates ? data.aggregates : []) {
      if (
        item.dimensionAttributeValues[dimensions.PRODUCT_LEVEL1] === element.l1
      ) {
        const curYtd = Number(
          checkNan(item.indicatorKpiValues.nbi_ytd).toFixed()
        );
        if (item.indicatorKpiValues.nbi_ytd !== 0) {
          NbiperBl += curYtd;
          const x = [];
          x.push(item.dimensionAttributeValues[dimensions.PRODUCT_LEVEL2]);
          x.push(curYtd / 1000);
          kpiDataSeries.push(x);
        }
      }
    }

    if (i < 5 || i === l1Values.length - 1) {
      const pos = i < 5 ? i : 5;
      const axisName = i < 5 ? element.l1 : "Others";
      kpiPieDrillDownData[pos] = {
        data: kpiDataSeries,
        id: axisName,
        name: axisName,
        nbiBL: NbiperBl / 1000,
      };
      kpiPieData[pos] = {
        drilldown: axisName,
        name: axisName,
        y: NbiperBl / 1000,
      };
    }
    i++;
  });

  pieData[0] = {
    colorByPoint: true,
    data: kpiPieData,
    name: "Product",
  };
  return new RevenuesPerProductsOutput(pieData, kpiPieDrillDownData);
}
function checkNan(value: number) {
  return isNaN(value) ? 0 : value;
}
